/**
 * Lệnh Bot — Cấu hình Share Pixel (/sharepixel).
 *
 * Trang nằm dưới prefix `/admin/lenh-bot/share-pixel`.
 */

export const SHARE_PIXEL_ROUTE_NAME = 'LenhBotSharePixel'
export const SHARE_PIXEL_ITEM_ID = 'lenh-bot-share-pixel'
/** Sidebar label — cùng pattern "Cấu hình Share Page" / "Cấu hình thu hồi Page" */
export const SHARE_PIXEL_LABEL = 'Cấu hình Share Pixel'
export const SHARE_PIXEL_TITLE = 'Lệnh Bot · Cấu hình Share Pixel'
